import React, { useContext } from 'react';
import {
    Box,
    Button,
    MenuItem,
    TextField,
    Autocomplete,
    Grid,
    FormControl,
    RadioGroup,
    FormControlLabel,
    Radio
} from '@mui/material';
import '../../assets/styles/FilterBar.scss';
import { GaintOFDOrdersContext } from '../../context';
import CommonDateRangePicker from '../common/CommonDateRangePicker';

export default function FilterBar() {
    const { filters, setFilters, initialFilters, onLoadApi, usersList, activeTab } = useContext(GaintOFDOrdersContext);

    const handleChange = (key, value) => {
        setFilters(prev => ({ ...prev, [key]: value }));
    };

    const handleDateRangeChange = ({ startDate, endDate }) => {
        setFilters(prev => ({
            ...prev,
            dateRange: { startDate, endDate }
        }));
    };

    const handleSubmit = () => {
        onLoadApi();
    };

    const handleReset = () => {
        setFilters(initialFilters);
        onLoadApi(initialFilters);
    };

    return (
        <Box className="shipment-filter-bar">
            <Grid container spacing={2}>
                <Grid item size={{ xs: 12, md: 3 }}>
                    <div className="search-box">
                        <TextField
                            select
                            name="searchBy"
                            value={filters.searchBy}
                            onChange={(e) => handleChange('searchBy', e.target.value)}
                            size="small"
                            className="search-select"
                        >
                            {activeTab === 2 ? (
                                [
                                    <MenuItem key="lrnum" value="lrnum">LR No.</MenuItem>,
                                    <MenuItem key="invoice_no" value="invoice_no">Invoice No.</MenuItem>
                                ]
                            ) : (
                                [
                                    <MenuItem key="awb_no" value="awb_no">AWB No.</MenuItem>,
                                    <MenuItem key="order_no" value="order_no">Order No.</MenuItem>
                                ]
                            )}
                        </TextField>

                        <TextField
                            size="small"
                            placeholder="Enter value"
                            value={filters.searchValue}
                            onChange={(e) => handleChange('searchValue', e.target.value)}
                            className="search-input"
                        />
                    </div>
                </Grid>

                <Grid item size={{ xs: 6, md: 3 }}>
                    <Autocomplete
                        options={usersList || []}
                        getOptionLabel={(option) => option.name || option.email || ''}
                        value={usersList.find(item => item.id === filters.from_user_id) || null}
                        onChange={(e, newValue) => {
                            handleChange('from_user_id', newValue ? newValue.id : null);
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="From User"
                                variant="outlined"
                                size="small"
                            />
                        )}
                    />
                </Grid>

                <Grid item size={{ xs: 6, md: 3 }}>
                    <Autocomplete
                        options={usersList || []}
                        getOptionLabel={(option) => option.name || option.email || ''}
                        value={usersList.find(item => item.id === filters.to_user_id) || null}
                        onChange={(e, newValue) => {
                            handleChange('to_user_id', newValue ? newValue.id : null);
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="To User"
                                variant="outlined"
                                size="small"
                            />
                        )}
                    />
                </Grid>

                <Grid item size={{ xs: 12, md: 3 }}>
                    <Box className="date-picker-wrapper">
                        <CommonDateRangePicker
                            startDate={filters?.dateRange?.startDate}
                            endDate={filters?.dateRange?.endDate}
                            onChange={handleDateRangeChange}
                            label="Assign Date"
                        />
                    </Box>
                </Grid>

                <Grid item size={{ xs: 12, md: 6 }}>
                    <FormControl component="fieldset" sx={{ mt: 0.5 }}>
                        <RadioGroup
                            row
                            aria-label="is_assigned"
                            name="is_assigned"
                            value={filters.is_assigned}
                            onChange={(e) => handleChange('is_assigned', e.target.value)}
                        >
                            <FormControlLabel value="1" control={<Radio size="small" />} label="Assigned User" />
                            <FormControlLabel value="0" control={<Radio size="small" />} label="Not Assigned User" />
                        </RadioGroup>
                    </FormControl>
                </Grid>

                <Grid item size={{ xs: 12, md: 6 }}>
                    <Box className="filter-actions" sx={{ justifyContent: 'flex-start', mt: 0.5 }}>
                        <Button className="search-btn" variant="contained" color="primary" size="medium" onClick={handleSubmit}>
                            Search
                        </Button>
                        <Button className="reset-btn ml-2" variant="outlined" color="primary" size="medium" onClick={handleReset}>
                            Reset
                        </Button>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
}
